import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../utils/axiosInstance";

const PaymentSuccess = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const query = new URLSearchParams(location.search);
    const sessionId = query.get("session_id");
    const packageId = query.get("packageId");

    const [paymentDetails, setPaymentDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const storedUser = JSON.parse(localStorage.getItem("carrierUser"));

    useEffect(() => {
        const fetchPayment = async () => {
            if (!sessionId) {
                setError("No session ID found in URL");
                setLoading(false);
                return;
            }

            try {
                // Fetch Stripe session details
                const { data } = await api.get(
                    `/payment/stripe-session/${sessionId}`
                );
                setPaymentDetails(data);

                // Save subscription to backend if user exists and packageId is available
                // if (storedUser?._id && packageId) {
                //     await api.post(
                //         "/payment/save-subscription",
                //         {
                //             carrierId: storedUser._id,
                //             packageId,
                //             subscriptionId: sessionId,
                //             currentPeriodEnd: data.subscription?.current_period_end
                //                 ? new Date(data.subscription.current_period_end * 1000)
                //                 : null,
                //             autoPayment: true,
                //             status: "active",
                //         }
                //     );
                // }
            } catch (err) {
                console.error("Error fetching payment details or saving subscription:", err);
                setError(err.response?.data?.error || err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchPayment();
    }, [sessionId, packageId, storedUser?._id]);

    if (loading)
        return <div className="text-center py-20 text-lg text-blue-600">Loading payment details...</div>;
    if (error)
        return <div className="text-center py-20 text-red-500 font-semibold">{error}</div>;
    if (!paymentDetails)
        return <div className="text-center py-20 text-gray-600">No payment details found.</div>;

    const session = paymentDetails.session || {};
    const subscription = paymentDetails.stripeSub || {};
    const lineItem = session.line_items?.data?.[0] || {};
    const metadata = session.metadata || {};
    const customer = session.customer_details || {};

    const packageName = lineItem.description || metadata.packageName || "N/A";
    const amountPaid = session.amount_total ? `$${(session.amount_total / 100).toFixed(2)}` : "N/A";
    const currency = session.currency ? session.currency.toUpperCase() : "N/A";
    const paymentStatus = session.payment_status || "N/A";
    const transactionId = session.invoice || session.payment_intent || "N/A";
    const packageIdDisplay = metadata.packageId || packageId || "N/A";
    const subscriptionId = paymentDetails.subscriptionId || session.subscription || "N/A";
    const subscriptionStatus = subscription.status || "active";

    return (
        <div className="flex items-center justify-center min-h-screen bg-blue-50 px-6">
            <div className="bg-white shadow-xl rounded-2xl p-10 max-w-5xl w-full grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Left side: Payment info */}
                <div className="flex flex-col justify-center">
                    <h1 className="text-4xl font-bold text-blue-600 mb-6">
                        ✅ Payment Successful
                    </h1>

                    <div className="space-y-3 text-gray-700 text-lg">
                        <p><strong>Package Name:</strong> {packageName}</p>
                        <p><strong>Amount Paid:</strong> {amountPaid}</p>
                        <p><strong>Currency:</strong> {currency}</p>
                        <p><strong>Customer Name:</strong> {customer.name || "N/A"}</p>
                        <p><strong>Customer Email:</strong> {customer.email || "N/A"}</p>
                        <p><strong>Payment Status:</strong> {paymentStatus}</p>
                        <p><strong>Transaction ID:</strong> {transactionId}</p>
                        <p><strong>Package ID:</strong> {packageIdDisplay}</p>
                        <p><strong>Subscription ID:</strong> {subscriptionId}</p>
                        <p><strong>Subscription Status:</strong> {subscriptionStatus}</p>
                    </div>

                    {/* Buttons */}
                    <div className="mt-8 flex flex-col sm:flex-row gap-4">
                        <button
                            onClick={() => navigate("/carrier/dashboard")}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-lg shadow-md transition duration-200"
                        >
                            Go to Dashboard
                        </button>
                    </div>
                </div>

                {/* Right side: Image */}
                <div className="flex items-center justify-center">
                    <img
                        src="/assets/paymentsuccess.webp"
                        alt="Payment Success"
                        className="w-full max-w-sm object-contain"
                    />
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;
